interface LineItem {
  sku: string;
  extendedSalePrice: number;
  isParcelItem: boolean;
}
const calculateCartTotalWithoutShipshield = (baseAmount: number,
  lineItems: LineItem[]) => {
  const shipshield = lineItems
    .find((item) => item.sku.startsWith('SHIPPED_ASSURANCE'))
  if (shipshield) {
    return baseAmount - shipshield.extendedSalePrice
  }
  return baseAmount
}

type ShipshieldEligibilityParams = {
  cartBaseAmount: number,
  lineItems: LineItem[],
}

const isShipshieldEligibleByAmountOf = (amount: number) => ({
  cartBaseAmount,
  lineItems,
}: ShipshieldEligibilityParams) => {
  const total = calculateCartTotalWithoutShipshield(cartBaseAmount, lineItems)
  return total < amount
}

export const isShipshieldEligibleByAmount = isShipshieldEligibleByAmountOf(500)

export const isShipshieldEligibleByItems = (lineItems: LineItem[]) => {
  const eligible = lineItems.reduce<boolean>((
    isAvailable,
    { isParcelItem },
  ) => Boolean(
    isAvailable
    && (isParcelItem === undefined || isParcelItem),
  ), true)
  return eligible
}
